import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// A one-shot request carried by a navigation: "open the New account dialog", "open this
// lead magnet". The nav flyout's quick actions and context lists send them; the screen
// they land on acts on it once and then clears it.
//
// Carried in history state rather than the URL, because it is an instruction, not an
// address: reloading the page or pressing Back must not reopen a dialog the user has
// already closed. Clearing it with a replace is what makes that true.
//
// `ready` lets a screen wait for its data — an intent naming a widget cannot be acted on
// before the widget list has loaded.
export function useNavIntent(onIntent, ready = true) {
  const location = useLocation();
  const navigate = useNavigate();
  const intent = location.state?.navIntent;

  // The handler usually closes over screen state, so it changes every render. Held in a
  // ref so the effect runs when the intent arrives, not whenever the screen re-renders.
  const handler = useRef(onIntent);
  handler.current = onIntent;

  useEffect(() => {
    if (!intent || !ready) return;
    handler.current(intent);
    navigate(`${location.pathname}${location.search}`, { replace: true, state: null });
  }, [intent, ready, navigate, location.pathname, location.search]);
}
